// apps/estelle/exam-blueprint.js — PR·2: Estelle's exam-simulation config. Unlike Alivia's CLEP
// (one standardized exam with an official domain blueprint), Estelle is high-school prep with no
// single standardized form — so there is NO official weighting to transcribe. The honest draw is
// EVEN across whatever tags her own bank holds, derived at draw time. The pacing marker is a
// generic placeholder until a specific test (ACT/SAT section, a class final) defines one.
export const BLUEPRINT_PLACEHOLDER = true; // no official blueprint exists for her — even draw by design

/** Build an even {tag: 1} blueprint over the tags actually present in the bank. */
export function evenBlueprint(items) {
  const tags = new Set();
  for (const q of items ?? []) for (const t of (q.tags?.length ? q.tags : (q.topic ? [q.topic] : []))) tags.add(t);
  return Object.fromEntries([...tags].map((t) => [t, 1]));
}

// Generic pacing until a specific exam is chosen (TODO: set from the real test's form).
export const SECONDS_PER_QUESTION = 60;
